import {
  postReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  exportExcelReq,
  END_POINTS
} from '@/api'
import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  searchInfo: {
    searchMonth: Utils.getMonthFirstDay(new Date()) // 2019-10-01
    // searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())]
    // startDt: null,
    // endDt: null
  },
  opStatInfo: {
    // rptMth: 0,
    // projId: '',
    // compId: '',
    rptMonth: new Date(0),
    settleDt: new Date(0),
    projMgr: '',
    rptEditor: '',
    rptStatus: '',
    finishBy: '',
    finishOn: new Date(0),
    incomeList: [],
    feeTreeList: [],
    storeList: [],
    targetList: []
  },
  // income
  editIncomeIndex: -1,
  editIncomeEntityId: '',
  editIncomeLastMthAmt: 0,
  editIncomeCurMthAmt: 0,
  editIncomeCheckedAmt: 0,
  editIncomeRemarks: '',
  // fee
  editFeeIndex: -1,
  editFeeEntityId: '',
  editFeeCheckedAmt: 0,
  editFeeRemarks: '',
  // store
  editStoreIndex: -1,
  editStoreEntityId: '',
  editStoreFeeAmt: 0,
  editStoreCheckedAmt: 0,
  editStoreRemarks: '',
  // target
  editTargetIndex: -1,
  editTargetEntityId: '',
  editTargetFeeAmt: 0,
  editTargetCheckedAmt: 0,
  editTargetRemarks: '',
  // editAction: '',
  // indEdit: 'N',
  END_STATE: null
}

const getters = {
  END_GETTERS() {}
}

const actions = {
  async updateReportInfo({
    dispatch,
    commit,
    state
  }, {projId, compId, codeParam, searchMonth}) {
    // console.log(transId)
    let rptMth = Utils.formatDateToMonthNum(searchMonth)
    // debugger
    let opStatInfo = {
      settleDt: state.opStatInfo.settleDt,
      projMgr: state.opStatInfo.projMgr,
      rptEditor: state.opStatInfo.rptEditor,
      //
      key: {
        rptMth: rptMth,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await postReq(END_POINTS.UPDATE_OP_STAT_INFO, {
      data: opStatInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async findOpStat({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam, rptMth }) {
    rptMth = new Date(rptMth).getTime()
    // endDt = new Date(endDt).getTime()
    const response = await postReq(END_POINTS.FIND_OP_STAT, {
      data: {
        projId: projId,
        compId: compId,
        rptMth: rptMth
        // ,
        // endDt: endDt
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateOpStatInfo', response)
  },
  async updateOpStatIncomeEntity({
    commit,
    state,
    rootState
  }, {rptMth, projId, compId, codeParam, entityName}) {
    // startDt = new Date(startDt).getTime()
    // endDt = new Date(endDt).getTime()
    // debugger
    const response = await postReq(END_POINTS.UPDATE_OP_STAT_INCOME_ENTITY, {
      data: {
        // entityId: entityId,
        entityName: entityName,
        lastMthAmt: state.editIncomeLastMthAmt || 0,
        curMthAmt: state.editIncomeCurMthAmt || 0,
        checkedAmt: state.editIncomeCheckedAmt || 0,
        remarks: state.editIncomeRemarks,
        //
        // rptEntityId: rptEntityId,
        rptMth: rptMth,
        projId: projId,
        compId: compId,
        entityId: state.editIncomeEntityId
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return response
    // commit('updateOpStatInfo', response)
  },
  async updateOpStatFeeEntity({
    commit,
    state,
    rootState
  }, {rptMth, projId, compId, codeParam, entityName}) {
    // startDt = new Date(startDt).getTime()
    // endDt = new Date(endDt).getTime()
    // debugger
    const response = await postReq(END_POINTS.UPDATE_OP_STAT_FEE_ENTITY, {
      data: {
        // entityId: entityId,
        entityName: entityName,
        checkedAmt: state.editFeeCheckedAmt || 0,
        remarks: state.editFeeRemarks,
        //
        rptMth: rptMth,
        projId: projId,
        compId: compId,
        entityId: state.editFeeEntityId
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return response
    // commit('updateOpStatInfo', response)
  },
  async updateOpStatStoreEntity({
    commit,
    state,
    rootState
  }, {rptMth, projId, compId, codeParam, entityName}) {
    // startDt = new Date(startDt).getTime()
    // endDt = new Date(endDt).getTime()
    // debugger
    const response = await postReq(END_POINTS.UPDATE_OP_STAT_STORE_ENTITY, {
      data: {
        // entityId: entityId,
        entityName: entityName,
        feeAmt: state.editStoreFeeAmt || 0,
        checkedAmt: state.editStoreCheckedAmt || 0,
        remarks: state.editStoreRemarks,
        //
        // rptEntityId: rptEntityId,
        rptMth: rptMth,
        projId: projId,
        compId: compId,
        entityId: state.editStoreEntityId
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return response
    // commit('updateOpStatInfo', response)
  },
  async updateOpStatTargetEntity({
    commit,
    state,
    rootState
  }, {rptMth, projId, compId, codeParam, entityName}) {
    // startDt = new Date(startDt).getTime()
    // endDt = new Date(endDt).getTime()
    // debugger
    const response = await postReq(END_POINTS.UPDATE_OP_STAT_TARGET_ENTITY, {
      data: {
        // entityId: entityId,
        entityName: entityName,
        feeAmt: state.editTargetFeeAmt || 0,
        checkedAmt: state.editTargetCheckedAmt || 0,
        remarks: state.editTargetRemarks,
        //
        // rptEntityId: rptEntityId,
        rptMth: rptMth,
        projId: projId,
        compId: compId,
        entityId: state.editTargetEntityId
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return response
    // commit('updateOpStatInfo', response)
  },
  async downloadOpStat({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam, rptMth }) {
    rptMth = new Date(rptMth).getTime()
    // endDt = new Date(endDt).getTime()
    const response = await exportExcelReq(END_POINTS.DOWNLOAD_OP_STAT, {
      data: {
        projId: projId,
        compId: compId,
        rptMth: rptMth
        // ,
        // endDt: endDt
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    // commit('updateOpStatInfo', response)
    return response
  },
  END_ACTIONS() {}
}

const mutations = {
  updateSearchMonth(state, value) {
    state.searchInfo.searchMonth = value
  },
  // opStatInfo
  updateSettleDt(state, value) {
    state.opStatInfo.settleDt = value
  },
  updateProjMgr(state, value) {
    state.opStatInfo.projMgr = value
  },
  updateRptEditor(state, value) {
    state.opStatInfo.rptEditor = value
  },
  updateRptStatus(state, value) {
    state.opStatInfo.rptStatus = value
  },
  // enableEditPanel() {
  //   state.indEdit = 'Y'
  // },
  disableEditPanel() {
    // state.indEdit = 'N'
    state.editIncomeIndex = -1
    state.editIncomeEntityId = ''
    state.editIncomeLastMthAmt = 0
    state.editIncomeCurMthAmt = 0
    state.editIncomeCheckedAmt = 0
    state.editIncomeRemarks = ''
    //
    state.editFeeIndex = -1
    state.editFeeEntityId = ''
    state.editFeeCheckedAmt = 0
    state.editFeeRemarks = ''
    //
    state.editStoreIndex = -1
    state.editStoreEntityId = ''
    state.editStoreLastMthAmt = 0
    state.editStoreCurMthAmt = 0
    state.editStoreCheckedAmt = 0
    state.editStoreRemarks = ''
    //
    state.editTargetIndex = -1
    state.editTargetEntityId = ''
    state.editTargetLastMthAmt = 0
    state.editTargetCurMthAmt = 0
    state.editTargetCheckedAmt = 0
    state.editTargetRemarks = ''
  },
  //
  updateEditIncomeIndex(state, value) {
    state.editIncomeIndex = value
  },
  updateEditIncomeEntityId(state, value) {
    state.editIncomeEntityId = value
  },
  updateEditIncomeLastMthAmt(state, value) {
    state.editIncomeLastMthAmt = value
  },
  updateEditIncomeCurMthAmt(state, value) {
    state.editIncomeCurMthAmt = value
  },
  updateEditIncomeCheckedAmt(state, value) {
    state.editIncomeCheckedAmt = value
  },
  updateEditIncomeRemarks(state, value) {
    state.editIncomeRemarks = value
  },
  //
  updateEditFeeIndex(state, value) {
    state.editFeeIndex = value
  },
  updateEditFeeEntityId(state, value) {
    state.editFeeEntityId = value
  },
  updateEditFeeCheckedAmt(state, value) {
    state.editFeeCheckedAmt = value
  },
  updateEditFeeRemarks(state, value) {
    state.editFeeRemarks = value
  },
  //
  updateEditStoreIndex(state, value) {
    state.editStoreIndex = value
  },
  updateEditStoreEntityId(state, value) {
    state.editStoreEntityId = value
  },
  updateEditStoreFeeAmt(state, value) {
    state.editStoreFeeAmt = value
  },
  updateEditStoreCheckedAmt(state, value) {
    state.editStoreCheckedAmt = value
  },
  updateEditStoreRemarks(state, value) {
    state.editStoreRemarks = value
  },
  //
  updateEditTargetIndex(state, value) {
    state.editTargetIndex = value
  },
  updateEditTargetEntityId(state, value) {
    state.editTargetEntityId = value
  },
  updateEditTargetFeeAmt(state, value) {
    state.editTargetFeeAmt = value
  },
  updateEditTargetCheckedAmt(state, value) {
    state.editTargetCheckedAmt = value
  },
  updateEditTargetRemarks(state, value) {
    state.editTargetRemarks = value
  },
  // updateEditAction(state, value) {
  //   state.editAction = value
  // },
  updateOpStatInfo(state, response) {
    if (response.success) {
      state.opStatInfo = response.data
    } else {
      state.opStatInfo = {
        // rptMth: 0,
        // projId: '',
        // compId: '',
        rptMonth: new Date(0),
        settleDt: new Date(0),
        projMgr: '',
        rptEditor: '',
        rptStatus: '',
        finishBy: '',
        finishOn: new Date(0),
        incomeList: [],
        feeTreeList: [],
        storeList: [],
        targetList: []
      }
    }
  },
  updateOpStatInfoEmpty(state) {
    state.opStatInfo = {
      // rptMth: 0,
      // projId: '',
      // compId: '',
      rptMonth: new Date(0),
      settleDt: new Date(0),
      projMgr: '',
      rptEditor: '',
      rptStatus: '',
      finishBy: '',
      finishOn: new Date(0),
      incomeList: [],
      feeTreeList: [],
      storeList: [],
      targetList: []
    }
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/opStatManage.js